import { render, staticRenderFns } from "./Subject.vue?vue&type=template&id=5f2b0f1e&scoped=true&"
import script from "./Subject.vue?vue&type=script&lang=js&"
export * from "./Subject.vue?vue&type=script&lang=js&"
import style0 from "./Subject.vue?vue&type=style&index=0&id=5f2b0f1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2b0f1e",
  null
  
)

component.options.__file = "Subject.vue"
export default component.exports